import UserService from '@/services/UserService'
import { createRouter, createWebHistory } from 'vue-router'
import { bus } from '@/eventBus'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { public: true, noAuth: true },
    component: require('@/views/Home').default
  },
  {
    path: '/inactive',
    name: 'Inactive Network',
    meta: { public: true, noAuth: true },
    component: require('@/views/Inactive').default
  },
  {
    path: '/faq',
    name: 'FAQ',
    meta: { title: 'FAQ', public: true },
    component: require('@/views/FAQ').default
  },
  {
    path: '/about',
    name: 'About',
    meta: { title: 'About Us', public: true },
    component: require('@/views/About').default
  },
  {
    path: '/privacy',
    name: 'Privacy',
    meta: { title: 'Privacy Policy', public: true },
    component: require('@/views/Privacy').default
  },
  {
    path: '/terms',
    name: 'Terms',
    meta: { title: 'Terms of Use', public: true },
    component: require('@/views/Terms').default
  },
  {
    path: '/copyright',
    name: 'Copyright',
    meta: { title: 'Copyright Policy', public: true },
    component: require('@/views/Copyright').default
  },
  {
    path: '/account',
    name: 'My Account',
    meta: { title: 'My Account' },
    component: require('@/views/account/MyAccount').default
  },
  {
    path: '/account/subscription',
    name: 'My Subscription',
    meta: { title: 'My Subscription' },
    component: require('@/views/account/Subscription').default
  },
  {
    path: '/account/billing',
    name: 'Billing Information',
    meta: { title: 'Billing Information' },
    component: require('@/views/account/Billing').default
  },
  {
    path: '/forgot',
    name: 'Forgot Password',
    meta: { title: 'Forgot Password', public: true, noAuth: true },
    component: require('@/views/ForgotPassword').default
  },
  {
    path: '/subscribe',
    name: 'Subscribe No Type',
    meta: { title: 'Subscribe', public: true, noAuth: true },
    component: require('@/views/Register').default
  },
  {
    path: '/subscribe/:subtype',
    props: true,
    name: 'Subscribe',
    meta: { title: 'Subscribe', public: true, noAuth: true },
    component: require('@/views/Register').default
  },
  {
    path: '/live/:id?',
    props: true,
    name: 'Schedule',
    meta: { title: 'Live Stream' },
    component: require('@/components/Live').default
  },
  {
    path: '/live-now',
    name: 'Live Now',
    meta: { title: 'Live Now' },
    component: require('@/views/LiveNow').default
  },
  {
    path: '/video',
    name: 'Video Search',
    meta: { title: 'Video Search' },
    component: require('@/views/Search').default
  },
  {
    path: '/video/channel',
    props: true,
    name: 'Channel List',
    meta: { title: 'Channels' },
    component: require('@/components/ChannelList').default
  },
  {
    path: '/video/channel/:id',
    props: true,
    name: 'Channel Videos',
    meta: { title: 'Videos' },
    component: require('@/views/Channel').default
  },
  {
    path: '/video/watch/:id',
    props: true,
    name: 'Watch Video',
    meta: { title: 'Videos', jumbotron: 'false' },
    component: require('@/views/Video').default
  },
  {
    path: '/sso/:id/:hash/:timestamp',
    props: true,
    name: 'SSO',
    meta: { title: 'SSO', public: true },
    component: require('@/views/account/SingleSignOn').default
  },
  {
    path: '/invalid-network',
    name: 'Invalid Network',
    meta: { title: 'Not Found', public: true },
    component: require('@/components/InvalidNetwork').default
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Not Found',
    component: require('@/components/NotFound').default
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.path !== from.path) {
      return { left: 0, top: 0 }
    }
  }
})

router.beforeEach((to, from) => {
  const userInfo = UserService.getStorage('user')
  const networkInfo = UserService.getStorage('network')
  const loggedIn = (userInfo && userInfo.apikey !== null)

  if (networkInfo && +networkInfo.active !== 1) {
    localStorage.clear()
    bus.$emit('loggedOut')
    return { path: '/inactive' }
  }

  if (to.path.includes('/inactive') && networkInfo && +networkInfo.active === 1) {
    return { path: '/' }
  }

  if (!to.meta.public && !loggedIn) {
    return {
      path: '/',
      query: {
        errorTitle: 'Please Login',
        errorMessage: 'You need to login to access that page'
      }
    }
  }

  if (to.meta.noAuth && loggedIn) {
    return '/video/channel'
  }

  if (!to.path.includes('video/channel')) {
    bus.$emit('clearVideo')
  }

  let channelId = null
  if (to.path === '/video/channel' || to.path === '/video/channel/') {
    channelId = 0
  } else if (to.path.includes('video/channel')) {
    channelId = to.params.id
  }

  bus.$emit('setChannel', channelId)

  // Closest matched route with a title wins (deepest-first).
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  }
  if (networkInfo) {
    document.title += ' - ' + networkInfo.name
  }

  // Strip any meta tags we previously injected before adding the new set.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  if (nearestWithMeta) {
    nearestWithMeta.meta.metaTags
      .map(tagDef => {
        const tag = document.createElement('meta')
        Object.keys(tagDef).forEach(key => tag.setAttribute(key, tagDef[key]))
        tag.setAttribute('data-vue-router-controlled', '')
        return tag
      })
      .forEach(tag => document.head.appendChild(tag))
  }

  return true
})

export default router
